import logo from './logo.svg';
import './App.css';
import './Components/Navbar';
import { Navbar } from './Components/Navbar';
function App() {
  return(
  <>
    <Navbar/>
  </>);
}

export default App;
